<template>
  <div class="login-layout blur-login" :style="[isLoginApp ? {backgroundImage: `url(${require('@/assets/images/bg.png')})`} : '']">
  <div class="main-container">
    <div class="main-content">
      <div class="row">
        <div class="col-sm-10 col-sm-offset-1">
          <div class="login-container">
            <div v-bind:class="{'position-relative round_black': isNTT, 'position-relative' : !isNTT}">
              <div id="forgot-box" class="forgot-box visible widget-box no-border mt-0">
                <template v-if="sucessStatus === true">
                  <div class="widget-body">
                    <div class="widget-main">
                      <h4 class="header red lighter bigger">
                        <i class="ace-icon fa fa-key"></i>
                        パスワードリセット
                      </h4>
                      <div class="space-6"></div>
                      <div class="alert alert-success">
                        {{ message }}
                      </div>
                    </div><!-- /.widget-main -->

                    <div class="toolbar center">
                      <router-link tag="a" :to="{ name: 'login'}" class="back-to-login-link">
                        <i class="ace-icon fa fa-arrow-right"></i>
                        ログインページに戻る
                      </router-link>
                    </div>
                  </div><!-- /.widget-body -->
                </template>
                <template v-else>
                  <div class="widget-body">
                    <div class="widget-main">
                      <h4 class="header red lighter bigger">
                        <i class="ace-icon fa fa-key"></i>
                        パスワードリセット
                      </h4>
                      <div class="space-6"></div>
                      <div class="alert alert-danger" v-if="error === true">
                        {{ message }}
                      </div>
                      <form @submit.prevent="validateBeforeSubmit">
                        <fieldset>
                          <label class="block clearfix">
                            <span v-show="errors.has('ownerId')" class="error">{{ errors.first('ownerId') }}</span>
                            <span class="block input-icon input-icon-right">
                              <input :class="{ error: errors.has('ownerId') }" name="ownerId" type="text" class="form-control" v-validate="'required'" disabled  placeholder="事業者ID" v-model="credentials.ownerId" data-vv-as="名前"/>
                              <i class="ace-icon fa fa-user"></i>
                            </span>
                          </label>
                          <label class="block clearfix">
                            <span v-show="errors.has('userId')" class="error">{{ errors.first('userId') }}</span>
                            <span class="block input-icon input-icon-right">
                              <input v-if="isNTT" :class="{ error: errors.has('userId') }" disabled v-validate="'required'" name="userId" type="text" class="form-control" placeholder="会員ID" v-model="credentials.userId"/>
                              <input v-else :class="{ error: errors.has('userId') }" disabled v-validate="'required'" name="userId" type="text" class="form-control" placeholder="ユーザーID" v-model="credentials.userId"/>
                              <i class="ace-icon fa fa-user"></i>
                            </span>
                          </label>
                          <label class="block clearfix">
                            <span v-show="errors.has('resetCode')" class="error">{{ errors.first('resetCode') }}</span>
                            <span class="block input-icon input-icon-right">
                              <input :class="{ error: errors.has('resetCode') }" v-validate="'required|numeric'" name="resetCode" type="text" class="form-control" placeholder="メールにて通知されたリセットコードを入力" v-model="credentials.resetCode"/>
                              <i class="ace-icon fa fa-user"></i>
                            </span>
                          </label>
                          <span class="warring">
                            パスワードは英大文字、英小文字、数字を組み合わせた8文字以上に設定してください。
                          </span>
                          <label class="block clearfix">
                            <span v-show="errors.has('newPassword')" class="error">{{ errors.first('newPassword') }}</span>
                            <span class="block input-icon input-icon-right">
                              <input :class="{ error: errors.has('newPassword') }" v-validate="'regex:^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])'" name="newPassword" type="password" class="form-control" placeholder="新しいパスワード" v-model="credentials.newPassword"/>
                              <i class="ace-icon fa fa-lock"></i>
                            </span>
                          </label>
                          <label class="block clearfix">
                            <span class="block input-icon input-icon-right">
                              <input :class="{ error: errors.has('newPassword') }" v-validate name="newPassword" data-vv-rules="required|confirmed:newPassword" type="password" class="form-control" placeholder="再記入新しいパスワード"/>
                              <i class="ace-icon fa fa-lock"></i>
                            </span>
                          </label>
                          <div class="clearfix">
                            <router-link tag="button" :to="{ name: 'forgotpassword'}" class="width-40 pull-left btn btn-sm">
                              戻る
                            </router-link>
                            <button type="submit" class="width-40 pull-right btn btn-sm btn-danger">
                              <span class="bigger-110">送信</span>
                            </button>
                          </div>
                        </fieldset>
                      </form>
                    </div><!-- /.widget-main -->
                  </div><!-- /.widget-body -->
                </template>
              </div><!-- /.forgot-box -->
            </div><!-- /.position-relative -->
          </div>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.main-content -->
  </div><!-- /.main-container -->
  </div>
</template>

<script>
import * as Config from '../../config'

export default {
  data () {
    return {
      credentials: {
        ownerId: '',
        userId: '',
        resetCode: '',
        newPassword: ''
      },
      sucessStatus: false,
      error: '',
      message: '',
      isNTT: false,
      isLoginApp: false
    }
  },
  created () {
    this.credentials.ownerId = localStorage.ownerId
    this.credentials.userId = localStorage.userId
    var checkNTTWeb = navigator.userAgent.match(/isNTT/)
    if (checkNTTWeb) {
      this.isNTT = true
    }
    var isMobileApp = navigator.userAgent.match(/alligate-mobile-userAgent-ios|alligate-mobile-userAgent-android|isNTT|isUpgrade/g)
    if (isMobileApp) {
      if (isMobileApp.indexOf('isNTT') < 0 && isMobileApp.indexOf('isUpgrade') >= 0) {
        this.isLoginApp = true
      } else {
        this.isLoginApp = false
      }
    } else {
      this.isLoginApp = false
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const credentials = {
            ownerId: this.credentials.ownerId,
            userId: this.credentials.userId,
            resetCode: this.credentials.resetCode,
            newPassword: this.credentials.newPassword
          }
          this.$http.post(Config.RESET_PASSWORD_API, JSON.stringify(credentials))
            .then(response => {
              if (response.body.message === 'Success') {
                this.sucessStatus = true
                this.message = Config.RESET_API_SUCCESS_RESET_PASSWORD
              } else {
                this.error = true
                this.message = Config.RESET_API_ERROR_RESET_PASSWORD
              }
            })
            .catch((error) => {
              if (error.body) {
                this.error = true
                switch (error.status) {
                  case 401:
                    if (error.body.message === 'The incoming token has expired') {
                      this.message = ''
                    } else {
                      this.message = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                    }
                    break
                  case 400:
                    this.message = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                    break
                  case 444:
                    if (this.isNTT) {
                      this.message = '事業者ID、会員IDもしくはリセットコードが間違っています。'
                    } else {
                      this.message = '事業者ID、ユーザーIDもしくはリセットコードが間違っています。'
                    }
                    break
                  case 445:
                    if (this.isNTT) {
                      this.message = '事業者ID、会員IDもしくはリセットコードが間違っています。'
                    } else {
                      this.message = '事業者ID、ユーザーIDもしくはリセットコードが間違っています。'
                    }
                    break
                  case 500:
                    this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                    break
                  case 503:
                    this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                    break
                  default:
                    this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                    break
                }
              } else {
                this.error = true
                this.message = Config.SERVER_CONNECT_ERROR
              }
            })
        }
      })
    }
  }
}
</script>

<style>
.warring{
  background-color: #f2dede;
  border-color: #ebccd1;
  color: #a94442;
  padding: 8px 0px;
  display: inline-block;
  font-size: 14px;
  margin-bottom:5px
}
body{
  background: #394557
}
span.error {
  color: red;
}
input {
  border: 1px solid black;
}
input.error {
  border: 1px solid red;
}
.round_black .red  {
  color: #000 !important;
}
.round_black .btn-danger, .round_black .btn-danger.focus, .round_black .btn-danger:focus {
  background: #000 !important;
  border-color: #000 !important;
}
.round_black .forgot-box .toolbar {
  background: #000 !important;
  border-top: #000 !important;
}
.round_black .back-to-login-link {
  color: #fff !important;
}
.login-layout {
    min-height: 100vh;
    display: grid;
    align-content: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}
#mainContainer {
  padding-top: 0px !important
}
.login-layout .widget-box.visible.mt-0{
  margin-top: 0px !important;
}
@media only screen and (max-width: 500px) {
  .login-with-app .login-layout .login-button button {
    width: 90% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/ResetPassword.vue